import { TCoverModalSchema } from '../schema/CoverModalSchema'

export const isEmptyLocationValid = (data: TCoverModalSchema): boolean => {
  const { etaDriverLocation, trailerNumber, truckNumber, vinNumber } = data ?? {}
  if (!truckNumber && !trailerNumber && !vinNumber) {
    return true
  }
  const { location } = etaDriverLocation ?? {}
  const { city, state } = location ?? {}
  const hasValidLocation = Boolean(state) && Boolean(city)
  return hasValidLocation
}
